import type { FaireProductEntity } from "../../entity_types/product";

export const p_sa6nyvmjn5: FaireProductEntity = {
  token: "p_sa6nyvmjn5",
  type: "product",
  name: "Time to Read! With Elephant & Piggie: 50 Bookplate Stickers",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/ab23ac0395f6e26b107af9f60e8bcd29fd276a7308f592794885d3730322d9e7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3142d9cdb0a02b24427ea57d307d677d6390821cd6a5b130141e6e99e8288195.jpeg"
  ],
  priceDollars: 5,
  description: "Delight young readers with this charming pack of 50 bookplates featuring Mo Willems’ beloved characters, Elephant & Piggie! Perfect for personalizing classroom libraries, gifts, or home collections, each self-adhesive bookplate includes space for a name alongside playful illustrations that capture the humor and warmth of Willems’ award-winning book characters! Simply peel, place, and inscribe to add a special touch to any kid’s book. Use these bookplates on their own, or pair with the Elephant & Piggie Bookstop bookmarks or the From My Library! personal library kit. These charming kids’ bookplates feature beloved Mo Willems characters & support kids’ love of reading, collecting, and sharing books! Playful illustrations capture the humor and warmth of Willems’ award-winning characters. 4.5 x 6.5–inch portfolio; 50 adhesive bookplates in 5 different designs.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:00.345Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
